import { Chart } from 'chart.js'
import dayjs from 'dayjs'
import { getFontSize } from '../../../../../utils/getFontSize'

export const createPanelProductionChart = (
	e: HTMLCanvasElement,
	chartData: { value: number; date: string }[],
	darkModeEnabled: boolean
) => {
	const borderColor = darkModeEnabled ? '#3cb49f' : '#52ae32'
	const scalesColor = darkModeEnabled ? '#c8c8c8' : '#a3a3a3'
	const values = chartData.map(x => Number((x.value * 1000).toFixed(0)))
	const labels = chartData.map(e => dayjs(e.date, 'YYYY-MM-DD HH').format('HH:mm'))

	const fontSize = getFontSize()

	const chart = new Chart(e, {
		type: 'line',
		data: {
			labels: labels,
			datasets: [
				{
					borderColor,
					data: values,
					borderWidth: 2,
					label: 'W',
				},
			],
		},
		options: {
			devicePixelRatio: 2,
			maintainAspectRatio: false,
			scales: {
				y: {
					grid: {
						display: false,
					},
					ticks: {
						maxTicksLimit: 2,
						callback: value => String(Number(value)) + ' W',
						color: scalesColor,
						font: {
							size: fontSize,
						},
					},
					max: Math.ceil(Math.max(...values) / 1000) * 1000,
					min: 0,
				},
				x: {
					grid: {
						display: false,
					},
					ticks: {
						color: scalesColor,
					},
					border: {
						display: false,
					},
				},
			},
			elements: {
				point: {
					radius: 0,
				},
				line: {
					tension: 0.5,
				},
			},
			plugins: {
				tooltip: {
					titleFont: {
						size: fontSize + 2,
						weight: 'bold',
					},
					bodyFont: {
						size: fontSize,
					},
				},
				legend: {
					display: false,
					reverse: true,
				},
			},
		},
	})

	return chart
}
